/* istanbul ignore file */
import { number as codecNumber, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const UpdateSetAutoTestDataParser = 
/* #__PURE__ */ parsers.object([
    ['stopPoints', /* #__PURE__ */ codecOptional(codecNumber), 'stop_points'],
]);
export class UpdateSetAutoTestData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return UpdateSetAutoTestDataParser.decode(input).map(res => new UpdateSetAutoTestData(res));
    }
    static unsafeDecode(input) {
        return UpdateSetAutoTestData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UpdateSetAutoTestDataParser.encode(data);
    }
    static schema() {
        return UpdateSetAutoTestDataParser.schema();
    }
}
